import React, { useContext, useEffect, useState } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import Header from '../components/header/header'
import Sidebar from "../components/sidebar/sidebar";
import APIServicenew from "../utils/APIGeneralService.js";
import { UserContext } from "../context/UserContextProvider.js";
import Dashboard from '../pages/Dashboard/Dashboard.js';
import TodoList from '../pages/Todolist/TodoList';
import MomList from '../pages/mom/MomList';
import AddMom from '../pages/mom/AddMom.js';
import Calendar from '../pages/mom/Calendar.js';
import MomDetails from '../pages/mom/MomDetails.js';
import ChannelPartnerList from '../pages/ChannelPartner/ChannelPartnerList.js';
import ChannelDetails from '../pages/ChannelPartner/ChannelDetails.js';
import AddChannel from '../pages/ChannelPartner/AddChannel.js';
import Profile from '../pages/profile/Profile.js';
import MisReport from '../pages/MisReport/MisReport.js';
import MisDetails from '../pages/MisReport/MisDetails.js';
import RMList from '../pages/RelationshipManager/RmList'
import RMDetails from '../pages/RelationshipManager/ManagerDetails'
import AddRM from '../pages/RelationshipManager/Addmanager.js';
import TargetAchievement from '../pages/TargetAchievement/TargetAchievement.js';
import AddTarget from '../pages/TargetAchievement/AddTarget.js';
import RoleList from '../pages/RolesPermission/RoleList.js';
import AddRole from '../pages/RolesPermission/AddRole.js';
import AddMember from '../pages/MemberManagement/Addmamber.js';
import MemberList from '../pages/MemberManagement/MemberList.js';
import AddSubadmin from '../pages/SubAdmin/AddSubadmin.js';
import ManageAdmin from '../pages/SubAdmin/ManageAdmin.js';
import AddProduct from '../pages/ProductManagement/AddProduct.js';
import ProductList from '../pages/ProductManagement/ProductManagement.js';
import ProductDetails from "../pages/ProductManagement/ProductDetails.js";
import TargetDetails from  "../pages/TargetAchievement/TargetDetails.js"
import AddExpense from "../pages/mom/AddExpenses.js";
import MemberDetails from "../pages/MemberManagement/MemberDetails.js";
import RMType from "../pages/Settings/RMType.js"
import AddRMType from "../pages/Settings/Add-RMType.js";
import ChannelType from "../pages/Settings/channelType.js";
import AddChannelType from "../pages/Settings/Add-channelType.js";
import RMCategory from "../pages/Settings/RM-category.js";
import AddRMCategory from "../pages/Settings/Add-RM-Category.js";
import Region from "../pages/Settings/Region.js"
import AddRegion from "../pages/Settings/Add-region.js"
import State from "../pages/Settings/state.js";
import AddState from "../pages/Settings/Add-state.js";
import City from "../pages/Settings/city.js";
import AddCity from "../pages/Settings/Add-city.js";

const Admin = (props) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <>

      <div className='alf_dashboard_area'>
        <Header />
        <Container fluid>
          <section className='alf_dashboard_inner py-3'>
            <aside>
              <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
            </aside>
            <div className={`alf_inner_content ${isOpen ? "open" : "close"}`}>
              <Routes>
                <Route path="/profile" element={<Profile />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/todo-list" element={<TodoList />} />
                <Route path="/mom-list" element={<MomList />} />
                <Route path="/add-mom" element={<AddMom />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/mom-details/:id" element={<MomDetails />} />
                <Route path="/add-expenses/:id" element={<AddExpense />} />
                <Route path="/channel-partner" element={<ChannelPartnerList />} />
                <Route path="/channel-details/:id" element={<ChannelDetails />} />
                <Route path="/add-channel" element={<AddChannel />} />
                <Route path="/update-channel/:id" element={<AddChannel />} />
                <Route path="/mis-report" element={<MisReport />} />
                <Route path="/mis-details" element={<MisDetails />} />
                <Route path="/rm-list" element={<RMList />} />
                <Route path="/rm-details/:id" element={<RMDetails />} />
                <Route path="/add-rm" element={<AddRM />} />
                <Route path="/update-rm/:id" element={<AddRM />} />
                <Route path="/target-achievement" element={<TargetAchievement />} />
                <Route path="/add-target" element={<AddTarget />} />
                <Route path="/update-targets/:id?" element={<AddTarget />} />
                <Route path="/target-details/:id?" element={<TargetDetails />} />
                <Route path="/add-role/:id?" element={<AddRole />} />
                <Route path="/role-list" element={<RoleList />} />
                <Route path="/sub-admin" element={<ManageAdmin />} />
                <Route path="/update-sub-admin/:id?" element={<AddSubadmin />} />
                <Route path="/add-sub-admin" element={<AddSubadmin />} />
                <Route path="/members" element={<MemberList />} />
                <Route path="/add-members" element={<AddMember />} />
                <Route path="/update-members/:id?" element={<AddMember />} />
                <Route path="/member-details/:id?" element={<MemberDetails />} />
                <Route path="/products" element={<ProductList />} />
                <Route path="/add-products" element={<AddProduct />} />
                <Route path="/update-products/:id?" element={<AddProduct />} />
                <Route path="/product-details/:id?" element={<ProductDetails />} />
                <Route path="/rm-type" element={<RMType />} />
                <Route path="/add-rm-type" element={<AddRMType />} />
                <Route path="/update-rm-type/:id?" element={<AddRMType />} />
                <Route path="/ch-type" element={<ChannelType />} />
                <Route path="/add-ch-type" element={<AddChannelType />} />
                <Route path="/update-ch-type/:id?" element={<AddChannelType />} />
                <Route path="/rm-category" element={<RMCategory/>} />
                <Route path="/add-rm-category" element={<AddRMCategory />} />
                <Route path="/update-rm-category/:id?" element={<AddRMCategory />} />
                <Route path="/region" element={<Region />} />
                <Route path="/add-region" element={<AddRegion />} />
                <Route path="/update-region/:id?" element={<AddRegion />} />
                <Route path="/state" element={<State />} />
                <Route path="/add-state" element={<AddState />} />
                <Route path="/update-state/:id?" element={<AddState />} />
                <Route path="/city" element={<City />} />
                <Route path="/add-city" element={<AddCity />} />
                <Route path="/update-city/:id?" element={<AddCity />} />

              </Routes>
            </div>
          </section>
        </Container>
      </div>
    </>
  );
};

export default Admin;
